// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("C:\\Users\\artur\\lostit\\src\\pages\\404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("C:\\Users\\artur\\lostit\\src\\pages\\index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-rodo-js": () => import("C:\\Users\\artur\\lostit\\src\\pages\\rodo.js" /* webpackChunkName: "component---src-pages-rodo-js" */),
  "component---src-pages-wiecej-js": () => import("C:\\Users\\artur\\lostit\\src\\pages\\wiecej.js" /* webpackChunkName: "component---src-pages-wiecej-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "C:\\Users\\artur\\lostit\\.cache\\data.json")

